import { render, staticRenderFns } from "./JobsTreeDepartmentItem.vue?vue&type=template&id=fa87b2f0"
import script from "./JobsTreeDepartmentItem.vue?vue&type=script&lang=js"
export * from "./JobsTreeDepartmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports